import React from "react";
import "./Questions.scss";
import ButtonExit from "../ButtonExit/ButtonExit";

const Questions = () => {
  return (
    <section className="questions">
      <h4 className="questions__text">
        Откройте для себя новый способ путешествовать и наслаждаться красотами
        природы! SUP-серфинг - это то, что вам нужно Вы можете наслаждаться
        тишиной и спокойствием, ощущая легкий бриз на лице, исследовать новые
        места и окунуться в воду, когда хочется освежиться. Весь парк досок –
        абсолютно новый. Есть все необходимое для безопасной прогулки
        (спас-жилет, герметичный чехол для телефона) Весь инструкторский состав
        имеет допуски и знания относительно поведения на воде, навыки оказания
        ПМП. Ограничения: Максимально допустимая масса – 200 кг Независимо от
        того, являетесь ли вы опытным гонщиком или новичком, наша доска SUP
        легко управляется и обеспечит вам максимальное удовольствие от
        путешествия.
      </h4>

      {/* <p className="questions__text-explanation">
        ✅ Обязательно возьмите головной убор!!!🧢
      </p> */}
      <ButtonExit />
    </section>
  );
};

export default Questions;
